import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
import { ExpandingWildsBulkFactory, ExpandingWildsBulk, ExpandingWildsBulkParam } from "../../slot/ExpandingWildBulk";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { AudioManager } from "../../AudioManager";
import { SlotGameInitData } from "../../SlotGameInitData";
import { MultigameParams } from "../../MultigameParams";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FontResource } from "../../ResourceManager/FontResource";
// import { ImageResource } from "../../ResourceManager/ImageResource";
import { Rect, SetStyles, Log } from "../.././MyHelpers";
// import { Sprite } from "../Sprite/Sprite";
// import { SpriteResource } from "../../ResourceManager/SpriteResource";
// import { CanvasSprite } from "../Sprite/CanvasSprite";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { FreegameBonusFactory, FreegameBonus, FreegameBonusParams, FreegamePickElemGeometry, FreegamePickElementParams } from "../FreegameBonus/FreegameBonus";
import { FreegameStates } from "../FreegameBonus/FreegameState";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { PickBonusFactory, PickBonus } from "../PickBonus/PickBonus";
import { PickBonusState } from "../PickBonus/PickBonusState";
import { PickBonusMessages } from "../PickBonus/PickMessage";
import { PickBonusParams, PickBonusPickElementParams, PickBonusReward } from "../PickBonus/PickBonusParams";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { IPlusOneFactory } from "../FreegameBonus/IPlusOneFactory";
import { SpritePlusOneFactory } from "../FreegameBonus/SpritePlusOneFactory";
// namespace SlotGames {
export class MayanHeroesFillingPot extends SlotGameType1 {	
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "MayanHeroesFillingPot");
		this.spinnableReelsParams.topBorderWidth = 6;
		this.spinnableReelsParams.bottomBorderWidth = 6;
	}
}